import { DoneOutline, Info } from "@mui/icons-material";
import { Divider } from "@mui/material";
import React from "react";
import * as msg from "utils/constants/messages";
import * as c from "utils/constants/constants";

const NotAvailableWarning = (props) => {
    return <>
        <div className="block-save">
            <Info style={{ color: "var(--hti-magenta)" }} />
            <div>{msg.not_available_warning_message}</div>
        </div>
        <Divider />

        <div
            className="icon-text"
            style={{ justifyContent: "center", marginTop: "10px" }}
        >
            {
                !props.duplicateDocumentView && localStorage.getItem(c.PREV_ROUTE) === "docMgmt" && <button
                    className="apply-button"
                    style={{ width: "max-content", marginRight: "0px" }}
                    onClick={props.onPrev}
                >
                    <p className="apply-button-text">Prev</p>
                </button>
            }
            <button
                className="apply-button"
                style={{ width: "max-content", margin: "0px 10px" }}
                onClick={props.goToDocManagement}
            >
                <p className="apply-button-text">Go to DocManagement</p>
            </button>
            {
                !props.duplicateDocumentView && localStorage.getItem(c.PREV_ROUTE) === "docMgmt" && <button
                    className="apply-button"
                    style={{ width: "max-content", marginRight: "0px" }}
                    onClick={props.onNext}
                >
                    <p className="apply-button-text">Next</p>
                </button>
            }
        </div>
    </>
}

export default NotAvailableWarning;